import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import PayPalCheckoutButton from "../../../../../components/PayPalCheckoutButton/PayPalCheckoutButton";
import localeText from "../../../../../locale";

const UpgradePaymentCheckoutStep = ({
  plan,
  voucher,
  useVoucherCheck,
  loadingArea,
  loadingBusiness,
  loadingSeller,
  loadingPassword,
  userTypeInfo,
  currencyCode,
  priceForex,
  toastUpgrade,
  setVoucher,
  setUseVoucherCheck,
  setLoadingPassword,
  onUpgradeWithVoucher,
  onBackToPlans,
}) => {
  const isPaymentLoading = loadingArea || loadingBusiness || loadingSeller;

  return (
    <>
      {/* <h2>{localeText("upgradePaymentTitle")}</h2> */}
      {!loadingPassword && (
        <Button
          className="p-button "
          link
          label={localeText("previous")}
          icon="pi pi-arrow-left"
          onClick={onBackToPlans}
        />
      )}
      {plan === 2 && useVoucherCheck && (
        <div className="upgrade-page-voucher-box">
          <label htmlFor="voucher">{localeText("voucher")}</label>
          <InputText
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
            name="voucher"
            id="voucher"
          />
          <Button
            label={localeText("upgradeWithVoucher")}
            onClick={onUpgradeWithVoucher}
            loading={loadingArea}
          />
        </div>
      )}

      {isPaymentLoading && (
        <div className="text-center">
          <i className="pi pi-spin pi-spinner text-8xl text-500 my-8"></i>
        </div>
      )}

      {!isPaymentLoading && (
        <>
          {(plan !== 2 || !useVoucherCheck) && (
            <div className="upgrade-page-paypal-wrapper">
              <PayPalCheckoutButton
                upgrade={true}
                plan_={plan}
                userTypeInfo={userTypeInfo}
                currencyCode={currencyCode}
                price={priceForex}
                loading={loadingPassword}
                setLoading={setLoadingPassword}
                toastUpgrade={toastUpgrade}
              />
            </div>
          )}
          {plan === 2 && !loadingPassword && (
            <div className="upgrade-page-voucher-check">
              <label htmlFor="usevouchercheck">{localeText("doYouHaveVoucher")}</label>
              <Checkbox
                className="sc-checkbox"
                name="usevouchercheck"
                inputId="usevouchercheck"
                onChange={(e) => setUseVoucherCheck(e.checked)}
                checked={useVoucherCheck}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default UpgradePaymentCheckoutStep;
